import ViewSheet from "@/v2-backoffice-client/components/viewSheet"
import AppViewSheetBreadcrumb from "@/v2-backoffice-client/app/AppViewSheetBreadcrumb"
import LayerCatgoryViewInfo from "@/v2-backoffice-client/layer/category/view/LayerCatgoryViewInfo"
import LayerCategoryLayerList from "@/v2-backoffice-client/layer/category/layer/LayerCategoryLayerList"
import { useLayerCategoryViewQuery } from "@/v2-backoffice-client/layer/category/view/layer.category.view.query"
import { useAppViewSheetOpener } from "@/v2-backoffice-client/app/app.utils"

function LayerCategoryViewSheet() {
  const { id } = useAppViewSheetOpener()
  const featureCode = String(id)

  const { data, loading, error } = useLayerCategoryViewQuery({
    skip: !featureCode,
    variables: {
      input: {
        featureCode,
      },
    },
  })

  const category = data?.getLayerCategoryByFeatureCode

  return (
    <>
      <ViewSheet.Header>
        <AppViewSheetBreadcrumb />
        <ViewSheet.Title isLoading={loading}>
          {category?.Name ?? category?.FeatureCode}
        </ViewSheet.Title>
      </ViewSheet.Header>

      <LayerCatgoryViewInfo
        category={category}
        isLoading={loading}
        error={error}
      />

      <LayerCategoryLayerList
        className="flex-1 p-3 space-y-3"
        featureCode={featureCode}
      />
    </>
  )
}

export default LayerCategoryViewSheet
